<template>
    <div class="  con_content">
       
        <div class="container">
            <div class="container_top h_48">话题管理</div>
           
            <!-- table组件 -->
            <div class="my_table">
               
                <div class="my_search">              
                    <Row class="search_row">  
                        <div  class="search_name">
                            
                            <Button class="mR5"    type="info"    @click='route="/layout/circle/gambit/add";addFun(-1)' > <Icon type="md-add" />添加</Button>
                            
                        </div>            
                    </Row>                 
                </div>
               
              
            </div>
             <!-- table组件 -->
            <div class="my_table  ">
                <Header class="my_title txt_l">
                    <b class="my_titleL">
                       <Icon class="fw_900 " type="ios-list" size='30'/>     
                        数据列表 
                    </b>
                    
                    <div class="ct_rgt">
                        
                        <!-- <div class="sta_btn " type="primary"   @click="exportData">导出数据</div> -->
                        
                    </div>
                </Header>
                <Table  style='bottom50'   border :columns="columns1" :data="data1" ref='table'>
                   
                    <!-- 排序 -->
                    <template slot-scope="{ row }" slot="sort">                       
                        <span v-if="row.level == 1" >{{row.sort}}</span>              
                        <b v-if="row.level == 0" class="cRed"  >{{row.sort}}</b>              
                    </template>
                    <!-- 分类名称 -->
                    <template slot-scope="{ row }" slot="title">                       
                        <span v-if="row.level == 1" >{{row.title}}</span>              
                        <b v-if="row.level == 0" class="cRed"  >{{row.title}}</b>              
                    </template>
                    <!-- 分类描述 -->
                    <template slot-scope="{ row }" slot="content">                       
                        <span v-if="row.level == 1" >{{row.content}}</span>              
                        <b v-if="row.level == 0" class="cRed"  >{{row.content}}</b>              
                    </template>

                    <!-- 图片 -->
                    <template slot-scope="{ row }" slot="image">                       
                        <Avatar  size="large" shape="square"    :src=" row.image2 "/>              
                    </template>
                 

                    <!-- 按钮 -->
                    <template slot-scope="{ row, index }" slot="btn">
                       
                        <Poptip trigger="hover"    content="添加">
                            <Button class="padlr5" size="small"  @click='route="/layout/circle/gambit/add";addFun(row)'   type="info"    icon="md-add"  ></Button>
                        </Poptip>  
                        <Poptip trigger="hover"   content="编辑">
                            <Button class="padlr5" size="small"  @click='route="/layout/circle/gambit/editor";editorFun(row)'  type="success"      icon="md-open"></Button>
                        </Poptip>
                        <Poptip trigger="hover"  content="删除">
                            <Button class="padlr5"  size="small" @click='route="/layout/circle/gambit/del";delFun(row)'  type="error"      icon="md-close"></Button>
                        </Poptip>
                       
                    </template>
                    
                </Table>
                <div class="h50 "></div>
                
                <!-- 添加弹窗 -->
                <Modal
                    v-model="modal1"
                    title="话题添加"
                  
                    class-name="vertical-center-modal"
                >
                    <div slot="footer">
                        <Button type='text' size='large' @click='cancel1'>取消</Button>
                        <Button type='primary' size='large' @click='ok1'>添加</Button>
                    </div>
                    <ul class="list_ul">
                        <!-- 排序 -->
                        <li>
                            <div class='list_title'>  父级 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="" v-model="model0" disabled  />
                            </div>                                            
                        </li>
                        <!-- 分类名称/标题 -->
                        <li>
                            <div class='list_title'> <b class="cRed">*</b> 分类名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="请输入分类名称" v-model="model1"   />
                            </div>                                            
                        </li>
                        <!-- 话题图片 -->
                        <li>
                            <div class='list_title'> <b class="cRed">*</b> 分类图片 :</div> 
                            <div class="list_con" >
                                <cropper @childFun="childFun2"   :data="cropper_data1"  ></cropper>
                            </div>                                           
                        </li>
                        
                        
                        <!-- 分类描述 -->
                        <li>
                            <div class='list_title'>  <b class="cRed">*</b>分类描述 :</div> 
                            <div class="list_con">
                                <Input      type='textarea' :rows='10' class="ipt width"  placeholder="请输入分类描述" v-model="model3"   />
                            </div>                                            
                        </li>
                        <!-- 排序 -->
                        <li>
                            <div class='list_title'> <b class="cRed">*</b> 排序 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="请输入排序" v-model="model4"   />
                            </div>                                            
                        </li>
                       
                    </ul>
                </Modal>
                <!-- 编辑弹窗 -->
                <Modal
                    v-model="modal2"
                    title="话题编辑"
                  
                    class-name="vertical-center-modal"
                >
                    <div slot="footer">
                        <Button type='text' size='large' @click='cancel2'>取消</Button>
                        <Button type='primary' size='large' @click='ok2'>修改</Button>
                    </div>
                    <ul class="list_ul">
                        <!-- 排序 -->
                        <li>
                            <div class='list_title'>  名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="" v-model="model0" disabled  />
                            </div>                                            
                        </li>
                        <!-- 分类名称/标题 -->
                        <li>
                            <div class='list_title'>  分类名称 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="请输入分类名称" v-model="model1"   />
                            </div>                                            
                        </li>
                        <!-- 话题图片 -->
                        <li>
                            <div class='list_title'>  当前图片 :</div> 
                            <div class="list_con" >
                                <Avatar   shape="square" :src="ed_img"  size="large" />
                            </div>                                           
                        </li>
                        <!-- 话题图片按钮 -->
                        <li>
                            <div class='list_title'>  分类图片 :</div> 
                            <div class="list_con" >
                                <cropper @childFun="childFun2"   :data="cropper_data"  ></cropper>
                            </div>                                           
                        </li>
                        
                        
                        <!-- 分类描述 -->
                        <li>
                            <div class='list_title'>  分类描述 :</div> 
                            <div class="list_con">
                                <Input       type='textarea' :rows='10' class="ipt width"  placeholder="请输入分类描述" v-model="model3"   />
                            </div>                                            
                        </li>
                        <!-- 排序 -->
                        <li>
                            <div class='list_title'>  排序 :</div> 
                            <div class="list_con">
                                <Input      type='text' class="ipt width"  placeholder="请输入排序" v-model="model4"   />
                            </div>                                            
                        </li>
                       
                    </ul>
                </Modal>


                <!-- 确认删除框 -->
                <Modal
                    v-model="delM"
                    title="提示"
                    @on-ok="delOk"
                    @on-cancel="cancel"
                    class-name="vertical-center-modal"
                >
                    <p>确定删除该话题及该话题下帖子吗? </p>         
                </Modal>

          </div>

       </div>
       
  </div>
</template>

<script width>
    import { mapState,mapMutations,mapGetters } from 'vuex';
    import { setTimeout } from 'timers';
    import cropper from '../../child_vue/vue_cropper.vue';

    export default {
        name:'gambit',
        data () {
            return {
                route: null,
             
                token:'',
                guid: null,
                columns1:[],
                  
                data1:[],
                

                checkGuid2:'',
                levels: -1,
                sort: '',           //匹配

                lv1: false,        //第一级是否被点击过
                lv1: false,         //第二级是否被点击过

                val: -1,

                // 添加弹窗
                modal1: false,
                modal2: false,
                titleList: [],    //列表内容

                model0: null,
                model1: null,   //父级
                model2: null,   //权限名称
                model3: null,   //控制器/方法
                model4: null,   //图标名称
                model5: null,   //排序
                model6: false,

                editorGuid:null,
              
                delM: false,   //是否删除
                guid: '' ,        //删除的guid

                resList:[],  //要删除的对象的guid
                dataAll:[],       //所有的data


                allShow: '全部显示',

               

                
                image_back: null,      //上传图片后返回值

                ed_img: null,           //编辑中查看的图片

                cropper_data:{
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'1',            //图片分组
                    vCropper:'5',        //插件分组
                    enlarge:"1",         //倍数
                    autoCropWidth:"200",
                    autoCropHeight:"200"
                },  
                cropper_data1:{
                    btn_name: '上传图片',
                    outputType: 'jpeg',  //生成图片格式
                    type:'1',            //图片分组
                    vCropper:'6',        //插件分组
                    enlarge:"1",         //倍数
                    autoCropWidth:"200",
                    autoCropHeight:"200"
                },  

                child_val: null,  //child 反馈

            }
        },
        filters:{
            
        },
        created(){
           
        },
        components: {cropper},
        watch:{
         
        },
        computed: {
            is_change_layout(){
               return this.$store.getters.is_change_layout
            },
            is_change_vCropper(){
               return this.$store.getters.is_change_vCropper
            },
            
        },
        methods: {
          
           load(){
                let that = this;
                that.$myAjax.get( "admin/service/admin/trend/alltopic").then( function(res){
                    var data1 = res.data.data;
                    for(let i = 0; i<data1.length;i++){
                        data1[i].title2 = data1[i].title;
                        for(let j = 0;j<data1[i].level;j++){
                            data1[i].title2 = "|—"+data1[i].title2;
                        }
                        
                    }
                    
                    // 转base64
                    const USER_AGENT = navigator.userAgent.toLowerCase();
                    const isChrome = /.*(chrome)\/([\w.]+).*/;
    
                    if(!isChrome.test(USER_AGENT)){
                        for( let v = 0; v<data1.length;v++){

                            window.URL = window.URL || window.webkitURL;
                            var xhr = new XMLHttpRequest();
                            xhr.open("get", data1[v].image , true);
                            // 至关重要
                            xhr.responseType = "blob";
                            xhr.onload = function () {
                                
                                if (this.status == 200) {
                                    //得到一个blob对象
                                    var blob = this.response;
                                    // console.log("blob", blob)
                                    // 至关重要
                                    let oFileReader = new FileReader();
                                    oFileReader.onloadend = function (e) {
                                        let base64 = "";
                                        base64 = e.target.result;
                                        data1[v].image2 = base64;
                                    
                                    };
                                    oFileReader.readAsDataURL(blob);
                                    
                                }
                                
                            }

                            xhr.send();
                            
                        }
                        setTimeout(function(){
                            that.data1 = data1;
                        },350)
                    }else{
                        for( let v = 0; v<data1.length;v++){
                            data1[v].image2 = data1[v].image;
                        }
                        that.data1 = data1;
                    }
                    
                    
                    

                    that.columns1= [  
                
                      {title:'排序',key:'sort',render:(h,params) => {
                          return h('span',{
                            style:{
                                color: params.row.level == 0?'red':'515a6e',
                                fontWeight: params.row.level == 0?'900':'400',
                            },                       
                          },params.row.sort)
                      },align:'center',width:80},
                      {title:'分类图片',slot:'image',align:'center',width: 100},
                      {title:'分类名称',key:'title',render:(h,params) => {
                          return h('span',{
                            style:{
                                color: params.row.level == 0?'red':'515a6e',
                                fontWeight: params.row.level == 0?'900':'400',
                            },
                          
                            
                          },params.row.title2)
                      },align:'left',width:200},
                      {title:'分类描述',key:'content',render:(h,params) => {
                          return h('span',{
                            style:{
                                color: params.row.level == 0?'red':'515a6e',
                                fontWeight: params.row.level == 0?'900':'400',
                            },
                          
                            domProps:{
                              title: params.row.content
                            }
                          },params.row.content)
                      },align:'left',ellipsis: true},
                      {title:'操作',slot:'btn',align:'center',width: 180,fixed: 'right'},
                    ]
                   

                });
               
           },
               
          
          //    是否是按钮
           change_btn(bool){

           },
        //    全部显示
           listAllFun(){
                let that = this;

                if( that.data1.length != that.dataAll.length ){
                     that.data1 = that.dataAll.map(x => x);
                    
                }else{
                    
                     that.data1 = that.data_init.map(x => x);
                    
                }
                   
                
            
               
           },

           
            // 点击添加
            addFun(res){
                let that = this;
                that.guid = res.guid;

                that.$canBtn( that.route).then( function(res_c){
                    

                    that.modal1 = true;

                    if(res == -1){ 
                        that.model0   = '顶级';         
                        that.model1   = null;
                        that.model2   = null;
                        that.model3   = null;
                        that.model4   = null;
                        
                    }else{
                     
                        that.model0   = res.title;
                        that.model1   = null;
                        that.model2   = null;
                        that.model3   = null;
                        that.model4   = null;
                      
                    }
                })
               
               
            },
            //    添加弹窗
            ok1() {
                let that = this;
                
                let data = { 
                    title: that.model1,
                    image: null,             
                    content: that.model3,
                    sort:that.model4,
                    parentGuid: that.guid
                };
                if(!that.child_val){
                    that.$myAjax.post("admin/service/admin/trend/topic?route="+that.route,
                        data
                    ).then(res => {
                    
                        if(res.data.code != 0){
                            that.load();
                            that.cancel1();
                        }
                        
                    })
                }else{
                    that.$upload(
                        that.child_val
                    ).then(res => { 
                        data.image = res.data.data.name;
                        that.$myAjax.post("admin/service/admin/trend/topic?route="+that.route,
                            data
                        ).then(res => {
                        
                            if(res.data.code != 0){
                                that.load();
                                that.cancel1();
                            }
                            
                        })
                    }) 
                }
               
            },
            cancel1() {
                this.modal1 = false;

                this.model2 = null;
                this.model3 = null;
                this.model4 = null;
                this.model5 = null;
                this.model6 = false;
               
            },
            
          
            // 菜单编辑
            editorFun(res){
                let that = this;
                

                that.$canBtn( that.route).then( function(res_c){
                    that.guid = res.guid;
                    that.modal2 = true;
                    that.ed_img = res.image2;

                    that.model0   = res.title;
                    that.model1   = res.title;
                    that.model2   = null;
                    that.model3   = res.content;
                    that.model4   = res.sort;
                  
                    if(res.isButton == 0){
                        that.model6 = false; 
                    }else{
                        that.model6 = true;
                    }
               
                }) 
                
                
            },
           
            ok2() {
                var that = this;
                var data;
                
                data = {
                    title: that.model1,
                    image: null,
                    content: that.model3,
                    sort:that.model4,
                    guid: that.guid
                };
                if(!that.child_val){
                    that.$myAjax.put( 'admin/service/admin/trend/topic?route=' + that.route,
                        data
                    ).then(res => {                        
                        that.load();
                        that.cancel2();
                    })
                }else{
                    that.$upload(
                        that.child_val
                    ).then(res => { 
                        data.image = res.data.data.name;
                        that.$myAjax.put( 'admin/service/admin/trend/topic?route=' + that.route,
                            data
                        ).then(res => {
                            
                            if(res.data.code != 0){
                                that.load();
                                that.cancel2();
                        
                            };
                            
                        })
                    })
                    
                }
            },
            cancel2() {
                this.modal2 = false;

                this.model2 = null;
                this.model3 = null;
                this.model4 = null;
               
            },

            

            
            
            // 删除菜单
            delFun(res){
                let that = this;
           

                that.$canBtn( that.route).then( function(res_c){
                 
                    that.delM = true;
                    that.guid = res.guid;
                })
            },
            delOk(){
                let that = this;


                that.$myAjax.delete(
                   
                     'admin/service/admin/trend/topic?guid='+that.guid+'&route='+that.route,
                  
                ).then(res => {
                    that.load();
                   
                })
            },
            cancel(){},
            
            childFun2 (data){
                let that = this;
                that.child_val = data.pic_url;          
                
            },
     
        },
        mounted: function(){
           var that = this;
           that.vCropper = that.$store.state.vCropper;  //使用哪个cropper
           that.checkGuid = that.$store.state.checkGuid;
           that.token = that.$store.state.token;
           
           that.load();
           
            
        }
    }
</script>
<style scoped>
  
    @import "/css/modal.css";
   
   .width{
       width:330px!important;
   }
   .nameW{
       
       width: 40%;
       
   }
    .nameW:first-child{
       margin-right: 20%; 
    }
    
    .select li{
        padding: 5px;
    }
    .mSwitch{
        margin-top: 7px;
    }
</style>
